export const MANAGER_WORKED_LOG_LIST_REQUEST = 'MANAGER_WORKED_LOG_LIST_REQUEST';
export const SET_MANAGER_WORKED_LOG_LIST = 'SET_WORKED_LOG_LIST';
export const MANAGER_TWOFACTOR_LOG_LIST_REQUEST = 'MANAGER_TWOFACTOR_LOG_LIST_REQUEST';
export const SET_MANAGER_TWOFACTOR_LOG_LIST = 'SET_MANAGER_TWOFACTOR_LOG_LIST';
export const MANAGER_LOGIN_LOG_LIST_REQUEST = 'MANAGER_LOGIN_LOG_LIST_REQUEST';
export const SET_MANAGER_LOGIN_LOG_LIST = 'SET_MANAGER_LOGIN_LOG_LIST';
export const SET_LOG_PAGENATION = 'SET_LOG_PAGENATION';
export const SET_LOG_SEARCH_VAL = 'SET_LOG_SEARCH_VAL';
